export function setErrors(id, errors) {
  return {
    id: id,
    errors: errors,
    type: 'SET_ERRORS',
  }
}

export function clearErrors(id) {
  return {
    id: id,
    type: 'CLEAR_ERROR',
  }
}
